import React, { JSX } from "react";
import { Typography, Box } from "@mui/material";
import { Proposal } from "../../../../../../types/proposal.types";

interface IntroductionLetterRendererProps {
  proposal: Proposal;
}

const IntroductionLetterRenderer: React.FC<IntroductionLetterRendererProps> = ({
  proposal,
}) => {
  const formatDate = (dateString?: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const deceasedName = `${proposal.booking?.deceased?.[0]?.first_name || ""} ${proposal.booking?.deceased?.[0]?.surname || ""}`;
  const deceasedBirthDate = proposal.booking?.deceased?.[0]?.date_of_birth ?? "";
  const deceasedPassedDate = proposal.booking?.deceased?.[0]?.date_of_death ?? "";
  const clientName =
    `${proposal.booking?.contact?.first_name ?? ""} ${proposal.booking?.contact?.last_name ?? ""}`.trim();


  const replaceVariables = (text: string): (string | JSX.Element)[] => {
  const valuesToBold = [
    clientName,
    deceasedName,
    proposal.eventTitle,
    formatDate(deceasedBirthDate),
    formatDate(deceasedPassedDate),
    proposal.booking?.services?.[0]?.venue?.name,
    formatDate(proposal.booking?.services?.[0]?.date_of_service),
    new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
  ].filter(Boolean);

  let result: (string | JSX.Element)[] = [text];

  valuesToBold.forEach((value, index) => {
    if (!value) return;
    
    const newResult: (string | JSX.Element)[] = [];
    
    result.forEach((part) => {
      if (typeof part === 'string') {
        const parts = part.split(value);
        parts.forEach((p, i) => {
          if (i > 0) {
            newResult.push(
              <Box
                key={`${index}-${i}`}
                component="span"
                sx={{ fontWeight: 700, color: 'black' }}
              >
                {value}
              </Box>
            );
          }
          if (p) newResult.push(p);
        });
      } else {
        newResult.push(part);
      }
    });
    
    result = newResult;
  });

  return result;
};

  if (
    !proposal.introduction_letter ||
    proposal.introduction_letter.trim() === ""
  ) {
    return (
      <Typography
        variant="h6"
        sx={{
          whiteSpace: "pre-line",
          lineHeight: 1.8,
          fontStyle: "italic",
          color: "text.secondary",
        }}
      >
        No introduction letter provided.
      </Typography>
    );
  }

  return (
    <Typography
      variant="h6"
      sx={{
        whiteSpace: "pre-line",
        lineHeight: 1.8,
        textAlign: "justify",
      }}
    >
      {replaceVariables(proposal.introduction_letter)}
    </Typography>
  );
};

export default IntroductionLetterRenderer;
